export default [
  {
    section: 'ພາບລວມ',
    title: 'Home',
    icon: 'mdi-home',
    group_permissions: ['get_dashboard', 'get_activity'],
    menu: [
      {
        icon: 'mdi-home',
        title: 'home',
        to: '/welcome',
        permissions: [],
      },
      {
        icon: 'mdi-monitor-dashboard',
        title: 'dashboard',
        to: '/',
        permissions: ['get_dashboard'],
        except_roles: ['kbt'],
      },
      {
        icon: 'mdi-apps',
        title: 'Activity Log',
        to: '/activity-log',
        permissions: ['get_activity'],
        except_roles: ['kbt'],
      },
    ],
  },
  {
    section: 'ລູກຄ້າ ແລະ ບິນ',
    title: 'ຂໍ້ມູນລູກຄ້າ',
    icon: 'mdi-database',
    group_permissions: ['get_customer', 'get_customer_home', 'get_customer_company'],
    menu: [
      {
        icon: 'mdi-account-alert-outline',
        title: 'ລູກຄ້າທີ່ຍັງບໍ່ເຂົ້າບໍລິການ',
        to: '/pre-customer',
        permissions: ['get_customer'],
        except_roles: ['kbt'],
      },
      {
        icon: 'mdi-account-group',
        title: 'ລູກຄ້າຄົວເຮືອນ',
        to: '/customer',
        permissions: ['get_customer', 'get_customer_home'],
      },
      {
        icon: 'mdi-office-building',
        title: 'ລູກຄ້າຫົວໜ່ວຍທຸລະກິດ',
        to: '/company',
        permissions: ['get_customer', 'get_customer_company'],
        except_roles: ['kbt'],
      },
      {
        icon: 'mdi-account-group',
        title: 'ລູກຄ້າສົງຄຳຮ້ອງຂໍເຂົ້າມາ',
        to: '/company-request',
        permissions: ['get_customer'],
        except_roles: ['kbt'],
      },
    ],
  },
  // {
  //   title: "ບິນແບບເກົ່າ",
  //   icon: "mdi-note-outline",
  //   group_permissions: ["get_invoice"],
  //   menu: [
  //     {
  //       icon: "mdi-note-outline",
  //       title: "ຈັດການຂໍ້ມູນບິນ",
  //       to: "/invoice",
  //       permissions: ["get_invoice"],
  //     },
  //     {
  //       icon: "mdi-close-circle-outline",
  //       title: "ເຫດຜົນຍົກເລີກບິນ",
  //       to: "/reject",
  //       permissions: ["get_invoice"],
  //     },
  //   ],
  // },
  {
    section: 'ລູກຄ້າ ແລະ ບິນ',
    title: 'ຈັດການບິນ',
    icon: 'mdi-credit-card',
    except_roles: ['kbt'],
    group_permissions: ['get_invoice'],
    menu: [
      {
        icon: 'mdi-note-search',
        title: 'ຄົ້ນຫາບິນ',
        to: '/search-billing',
        permissions: ['get_invoice'],
      },
      {
        icon: 'mdi-note-outline',
        title: 'ບິນທັງໝົດ',
        to: '/billing',
        permissions: ['get_invoice'],
      },

      {
        icon: 'mdi-note-outline',
        title: 'ຈັດການບິນຢ້ອນຫຼັງ',
        to: '/v2/custom-bill',
        permissions: ['get_invoice'],
      },
      {
        icon: 'mdi-note-outline',
        title: 'ຈັດການບິນລ່ວງໜ້າ',
        to: '/future-invoice',
        permissions: ['get_invoice'],
      },
    ],
  },
  {
    section: 'ອະນຸມັດ · ລູກຄ້າທຸລະກິດ',
    title: 'ເພີ່ມລູກຄ້າທຸລະກິດ',
    icon: 'mdi-office-building-plus-outline',
    except_roles: ['kbt'],
    group_permissions: ['create_com', 'approve_com'],
    menu: [
      {
        icon: 'mdi-office-building-plus',
        title: 'ເພີ່ມລູກຄ້າທຸລະກິດ',
        to: '/company-submission',
        permissions: ['create_com'],
      },
      {
        icon: 'mdi-check-decagram',
        title: 'ອະນຸມັດລູກຄ້າທຸລະກິດ',
        to: '/company-submission-approval',
        permissions: ['approve_com'],
      },
      {
        icon: 'mdi-history',
        title: 'ປະຫວັດການອະນຸມັດ',
        to: '/company-submission-history',
        permissions: ['create_com', 'approve_com'],
      },
    ],
  },
  {
    section: 'ອະນຸມັດ · ລູກຄ້າທຸລະກິດ',
    title: 'ແກ້ໄຂລູກຄ້າທຸລະກິດ',
    icon: 'mdi-office-building-cog-outline',
    except_roles: ['kbt'],
    group_permissions: ['edit_com', 'approve_edit_com'],
    menu: [
      {
        icon: 'mdi-pencil',
        title: 'ແກ້ໄຂລູກຄ້າທຸລະກິດ',
        to: '/company-edit-request',
        permissions: ['edit_com'],
      },
      {
        icon: 'mdi-check-decagram',
        title: 'ອະນຸມັດການແກ້ໄຂ',
        to: '/company-edit-approval',
        permissions: ['approve_edit_com'],
      },
      {
        icon: 'mdi-history',
        title: 'ປະຫວັດການແກ້ໄຂ',
        to: '/company-edit-history',
        permissions: ['edit_com', 'approve_edit_com'],
      },
    ],
  },
  {
    section: 'ອະນຸມັດ · ລູກຄ້າທຸລະກິດ',
    title: 'ລຶບບິນທຸລະກິດ',
    icon: 'mdi-file-document-remove-outline',
    except_roles: ['kbt'],
    group_permissions: ['request_delete_bill_com', 'approve_delete_bill_com'],
    menu: [
      {
        icon: 'mdi-delete-clock-outline',
        title: 'ຂໍລຶບບິນທຸລະກິດ',
        to: '/bill-delete-request',
        permissions: ['request_delete_bill_com'],
      },
      {
        icon: 'mdi-check-decagram',
        title: 'ອະນຸມັດການລຶບບິນ',
        to: '/bill-delete-approval',
        permissions: ['approve_delete_bill_com'],
      },
      {
        icon: 'mdi-history',
        title: 'ປະຫວັດການລຶບບິນ',
        to: '/bill-delete-history',
        permissions: ['request_delete_bill_com', 'approve_delete_bill_com'],
      },
    ],
  },
  {
    section: 'ອະນຸມັດ · ລູກຄ້າທຸລະກິດ',
    title: 'ປິດສາຍບ້ານເປີດທຸລະກິດ',
    icon: 'mdi-home-export-outline',
    except_roles: ['kbt'],
    group_permissions: ['convert_home_com', 'approve_convert_home_com'],
    menu: [
      {
        icon: 'mdi-home-export-outline',
        title: 'ປິດສາຍບ້ານເປີດທຸລະກິດ',
        to: '/home-conversion',
        permissions: ['convert_home_com'],
      },
      {
        icon: 'mdi-check-decagram',
        title: 'ອະນຸມັດ ປິດສາຍບ້ານ',
        to: '/home-conversion-approval',
        permissions: ['approve_convert_home_com'],
      },
      {
        icon: 'mdi-history',
        title: 'ປະຫວັດ ປິດສາຍບ້ານ',
        to: '/home-conversion-history',
        permissions: ['convert_home_com', 'approve_convert_home_com'],
      },
    ],
  },
  {
    section: 'ອະນຸມັດ · ລູກຄ້າສາຍບ້ານ',
    title: 'ລຶບລູກຄ້າສາຍບ້ານ',
    icon: 'mdi-account-remove-outline',
    except_roles: ['kbt'],
    group_permissions: ['request_delete_home', 'approve_delete_home_1', 'approve_delete_home_2', 'approve_delete_home_3'],
    menu: [
      {
        icon: 'mdi-account-clock-outline',
        title: 'ຂໍລຶບລູກຄ້າສາຍບ້ານ',
        to: '/home-delete-request',
        permissions: ['request_delete_home'],
      },
      {
        icon: 'mdi-check-decagram',
        title: 'ອະນຸມັດການລຶບລູກຄ້າ',
        to: '/home-delete-approval',
        permissions: ['approve_delete_home_1', 'approve_delete_home_2', 'approve_delete_home_3'],
      },
      {
        icon: 'mdi-history',
        title: 'ປະຫວັດການລຶບລູກຄ້າ',
        to: '/home-delete-history',
        permissions: ['request_delete_home', 'approve_delete_home_1', 'approve_delete_home_2', 'approve_delete_home_3'],
      },
    ],
  },
  {
    section: 'ອະນຸມັດ · ລູກຄ້າສາຍບ້ານ',
    title: 'ລຶບບິນສາຍບ້ານ',
    icon: 'mdi-file-remove-outline',
    except_roles: ['kbt'],
    group_permissions: ['request_delete_bill_home', 'approve_delete_bill_home_1', 'approve_delete_bill_home_2', 'approve_delete_bill_home_3'],
    menu: [
      {
        icon: 'mdi-delete-clock-outline',
        title: 'ຂໍລຶບບິນສາຍບ້ານ',
        to: '/home-bill-delete-request',
        permissions: ['request_delete_bill_home'],
      },
      {
        icon: 'mdi-check-decagram',
        title: 'ອະນຸມັດການລຶບບິນສາຍບ້ານ',
        to: '/home-bill-delete-approval',
        permissions: ['approve_delete_bill_home_1', 'approve_delete_bill_home_2', 'approve_delete_bill_home_3'],
      },
      {
        icon: 'mdi-history',
        title: 'ປະຫວັດການລຶບບິນສາຍບ້ານ',
        to: '/home-bill-delete-history',
        permissions: ['request_delete_bill_home', 'approve_delete_bill_home_1', 'approve_delete_bill_home_2', 'approve_delete_bill_home_3'],
      },
    ],
  },
  {
    section: 'ອະນຸມັດ · ລູກຄ້າສາຍບ້ານ',
    title: 'ປິດ/ເປີດສາຍບ້ານ',
    icon: 'mdi-toggle-switch-outline',
    except_roles: ['kbt'],
    group_permissions: ['request_status_home', 'approve_status_home_1', 'approve_status_home_2', 'approve_status_home_3'],
    menu: [
      {
        icon: 'mdi-swap-horizontal',
        title: 'ຂໍປິດ/ເປີດສາຍບ້ານ',
        to: '/home-status-request',
        permissions: ['request_status_home'],
      },
      {
        icon: 'mdi-check-decagram',
        title: 'ອະນຸມັດປິດ/ເປີດສາຍບ້ານ',
        to: '/home-status-approval',
        permissions: ['approve_status_home_1', 'approve_status_home_2', 'approve_status_home_3'],
      },
      {
        icon: 'mdi-history',
        title: 'ປະຫວັດປິດ/ເປີດສາຍບ້ານ',
        to: '/home-status-history',
        permissions: ['request_status_home', 'approve_status_home_1', 'approve_status_home_2', 'approve_status_home_3'],
      },
    ],
  },
  {
    section: 'ການເກັບຂີ້ເຫຍື້ອ',
    title: 'ແຜນເສັ້ນທາງ',
    icon: 'mdi-map',
    except_roles: ['kbt'],
    group_permissions: ['get_route_plan'],
    menu: [
      {
        icon: 'mdi-sitemap',
        title: 'ເສັ້ນທາງເກັບຂີ້ເຫື້ຍອ',
        to: '/plan',
        permissions: ['get_route_plan'],
      },
      {
        icon: 'mdi-calendar-month',
        title: 'ຈັດແຜນເດີນລົດ',
        to: '/calendar',
        permissions: ['get_plan_calendar'],
      },
    ],
  },
  {
    section: 'ການເກັບຂີ້ເຫຍື້ອ',
    icon: 'mdi-delete',
    title: 'ເກັບຂີ້ເຫື້ຍອພິເສດ',
    except_roles: ['kbt'],
    permissions: ['manage_event', 'get_customer', 'get_customer_event'],
    to: '/v2/event-invoice',
    menu: [],
  },
  // Reports by area (report_finance / report_ar / report_customer / report_field / report_bank).
  {
    section: 'ລາຍງານ',
    title: 'ລາຍງານບິນ ແລະ ການເງິນ',
    icon: 'mdi-receipt-text-outline',
    // `report` opens every report group.
    group_permissions: ['report', 'report_finance'],
    menu: [
      {
        icon: 'mdi-cash-check',
        title: 'ລາຍງານການຈ່າຍບິນ',
        to: '/report/billing/payment-summary',
        permissions: ['report', 'report_finance'],
      },
      {
        icon: 'mdi-account-tie',
        title: 'ລາຍງານບິນເຊວ',
        to: '/report/invoice',
        permissions: ['report', 'report_finance'],
      },
      {
        icon: 'mdi-account-cash-outline',
        title: 'ລາຍງານເກັບເງິນ AR ພາກສະໜາມ',
        to: '/report/ar-field-collection',
        permissions: ['report', 'report_finance'],
      },
      {
        icon: 'mdi-qrcode',
        title: 'ລາຍງານການວາງບິນ AR ພາກສະໜາມ',
        to: '/report/ar-bill-placement',
        permissions: ['report', 'report_finance'],
      },
      {
        icon: 'mdi-account-cash',
        title: 'ລາຍງານບິນລູກຄ້າ',
        to: '/report/billing/customer',
        permissions: ['report', 'report_finance'],
      },
      {
        icon: 'mdi-calendar-star',
        title: 'ລາຍງານບິນເກັບພິເສດ',
        to: '/report/event/invoice',
        permissions: ['report', 'report_finance'],
      },
      {
        icon: 'mdi-chart-pie',
        title: 'ລາຍງານສະຫຼຸບຍອດບິນ',
        to: '/report/billing/totals-summary',
        permissions: ['report', 'report_finance'],
      },
      {
        icon: 'mdi-delete-clock',
        title: 'ປະຫວັດການລຶບບິນ (ກວດສອບ)',
        to: '/report/billing-removals',
        permissions: ['report', 'report_finance'],
      },
    ],
  },
  {
    section: 'ລາຍງານ',
    title: 'ລາຍງານໜີ້ຄ້າງ (AR)',
    icon: 'mdi-clock-alert-outline',
    // `report` opens every report group.
    group_permissions: ['report', 'report_ar'],
    menu: [
      {
        icon: 'mdi-account-clock',
        title: 'ໜີ້ຄ້າງຕາມລູກຄ້າ',
        to: '/report/ar-customers-as-of-date',
        permissions: ['report', 'report_ar'],
      },
      {
        icon: 'mdi-calendar-clock',
        title: 'ໜີ້ຄ້າງຕາມວັນທີ',
        to: '/report/ar-as-of-date-filtered',
        permissions: ['report', 'report_ar'],
      },
      {
        icon: 'mdi-office-building',
        title: 'ໜີ້ຄ້າງລູກຄ້າທຸລະກິດ',
        to: '/report/commercial-customer-ar',
        permissions: ['report', 'report_ar'],
      },
      {
        icon: 'mdi-home-account',
        title: 'ໜີ້ຄ້າງລູກຄ້າຄົວເຮືອນ',
        to: '/report/residential-customer-ar',
        permissions: ['report', 'report_ar'],
      },
    ],
  },
  {
    section: 'ລາຍງານ',
    title: 'ລາຍງານລູກຄ້າ',
    icon: 'mdi-account-group-outline',
    // `report` opens every report group.
    group_permissions: ['report', 'report_customer', 'report_com_activity', 'report_home_activity'],
    menu: [
      {
        icon: 'mdi-home-account',
        title: 'ລາຍງານລູກຄ້າຄົວເຮືອນ',
        to: '/report/customer',
        permissions: ['report', 'report_customer'],
      },
      {
        icon: 'mdi-office-building',
        title: 'ລາຍງານລູກຄ້າທຸລະກິດ',
        to: '/report/company',
        permissions: ['report', 'report_customer'],
      },
      {
        icon: 'mdi-file-chart-outline',
        title: 'ເຄື່ອນໄຫວລູກຄ້າທຸລະກິດ',
        to: '/report/company-activity',
        permissions: ['report_com_activity'],
      },
      {
        icon: 'mdi-home-analytics',
        title: 'ເຄື່ອນໄຫວລູກຄ້າສາຍບ້ານ',
        to: '/report/home-activity',
        // Only this permission (not `report`): the page and its Excel are for named people.
        permissions: ['report_home_activity'],
      },
    ],
  },
  {
    section: 'ລາຍງານ',
    title: 'ລາຍງານພາກສະໜາມ',
    icon: 'mdi-truck-outline',
    // `report` opens every report group.
    group_permissions: ['report', 'report_field'],
    menu: [
      {
        icon: 'mdi-calendar-check',
        title: 'ລາຍງານແຜນເກັບ',
        to: '/report/bag/plan-calendar/detail',
        permissions: ['report', 'report_field'],
      },
      {
        icon: 'mdi-card-account-details',
        title: 'ລາຍງານຄົນຂັບ',
        to: '/report/driver',
        permissions: ['report', 'report_field'],
      },
      {
        icon: 'mdi-truck',
        title: 'ເກັບຂີ້ເຫຍື້ອຕາມລົດ',
        to: '/report/driver/collection/v2',
        permissions: ['report', 'report_field'],
      },
      {
        icon: 'mdi-home-map-marker',
        title: 'ເກັບຂີ້ເຫຍື້ອຕາມບ້ານ',
        to: '/report/address/collection',
        permissions: ['report', 'report_field'],
      },
      {
        icon: 'mdi-delete-variant',
        title: 'ລາຍງານການເກັບຂີ້ເຫຍື້ອ',
        to: '/report/trash',
        permissions: ['report', 'report_field'],
      },
      {
        icon: 'mdi-calendar-star',
        title: 'ລາຍງານເກັບຂີ້ເຫຍື້ອພິເສດ',
        to: '/report/event/trash',
        permissions: ['report', 'report_field'],
      },
      {
        icon: 'mdi-map-marker-path',
        title: 'ຜົນງານການຂົນສົ່ງ',
        to: '/report/route-plan-result',
        permissions: ['report', 'report_field'],
      },
    ],
  },
  {
    section: 'ລາຍງານ',
    title: 'ລາຍງານທະນາຄານ',
    icon: 'mdi-bank-outline',
    // `report` opens every report group.
    group_permissions: ['report', 'report_bank'],
    menu: [
      {
        icon: 'mdi-bank-transfer',
        title: 'ການເຄື່ອນໄຫວ BCEL',
        to: '/report/transaction',
        permissions: ['report', 'report_bank'],
      },
      {
        icon: 'mdi-bank-transfer',
        title: 'ການເຄື່ອນໄຫວ LDB',
        to: '/report/transaction/ldb',
        permissions: ['report', 'report_bank'],
      },
    ],
  },
  {
    section: 'ລາຍງານ',
    title: 'Reconciliation',
    icon: 'mdi-bank-check',
    group_permissions: ['eod-ldb-reconciliation'],
    menu: [
      {
        icon: 'mdi-bank-transfer',
        title: 'EOD (Daily LDB)',
        to: '/eod/ldb-reconciliation',
        permissions: ['eod-ldb-reconciliation'],
      },
      {
        icon: 'mdi-bank-multiple',
        title: 'Bulk (Multi-Day)',
        to: '/eod/bulk-reconciliation',
        permissions: ['eod-ldb-reconciliation'],
      },
      {
        icon: 'mdi-qrcode-scan',
        title: 'QR Bill Number Search',
        to: '/eod/qr-search',
        permissions: ['eod-ldb-reconciliation'],
      },
      {
        icon: 'mdi-bank-transfer-in',
        title: 'LDB Payment Reference',
        to: '/eod/ldb-payment-reference',
        permissions: ['eod-ldb-reconciliation'],
      },
    ],
  },
  {
    section: 'ຕັ້ງຄ່າລະບົບ',
    title: 'ຈັດການຂໍ້ມູນ',
    icon: 'mdi-cog',
    group_permissions: [
      'get_role',
      'get_user',
      'get_customer',
      'get_driver',
      'get_address',
      'noti',
    ],
    except_roles: ['kbt'],
    menu: [
      {
        icon: 'mdi-bell-ring-outline',
        title: 'ຈັດການແຈ້ງເຕືອນລູກຄ້າ',
        to: '/noti',
        permissions: ['noti'],
      },
      {
        icon: 'mdi-account-key',
        title: 'Roles',
        to: '/role',
        permissions: ['get_role', 'create_role'],
      },
      {
        icon: 'mdi-package',
        title: 'ຈັດການຂໍ້ມູນບໍລິການ',
        to: '/package',
        permissions: ['get_package', 'get_customer'],
      },
      {
        icon: 'mdi-home-account',
        title: 'ຈັດການທີ່ຢູ່',
        to: '/village',
        permissions: ['get_address', 'get_driver'],
      },
      {
        icon: 'mdi-home-account',
        title: 'ຈັດການລາຍລະອຽດທີ່ຢູ່',
        to: '/village-variation',
        permissions: ['get_address', 'get_driver'],
      },
      {
        icon: 'mdi-car-multiple',
        title: 'ຈັດການພາຫະນະ',
        to: '/vehicle',
        permissions: ['get_vehicle'],
      },
    ],
  },
  {
    section: 'ຕັ້ງຄ່າລະບົບ',
    title: 'ຂໍ້ມູນຜູ້ໃຊ້',
    icon: 'mdi-account-supervisor',
    except_roles: ['kbt'],
    group_permissions: [
      'get_role',
      'get_user',
      'get_customer',
      'get_driver',
      'get_address',
    ],
    menu: [
      {
        icon: 'mdi-account-group-outline',
        title: 'ຜູ້ໃຊ້ທັງໝົດ',
        to: '/user',
        permissions: ['get_user'],
      },
      {
        icon: 'mdi-briefcase-account-outline',
        title: 'Sale Users',
        to: '/user-sale',
        permissions: ['get_user'],
      },
      {
        icon: 'mdi-dump-truck',
        title: 'Drivers',
        to: '/driver',
        permissions: ['get_driver'],
      },
      {
        icon: 'mdi-badge-account',
        title: 'ແອກລົດ',
        to: '/employee',
        permissions: ['get_employee'],
      },
      {
        icon: 'mdi-account-group',
        title: 'Team',
        to: '/team',
        permissions: ['get_team'],
      },
    ],
  },
  {
    section: 'ຕັ້ງຄ່າລະບົບ',
    title: 'ຈັດການຂັ້ນສູງ',
    icon: 'mdi-account-supervisor-circle',
    except_roles: ['kbt'],
    group_permissions: ['delete_any_customers', 'delete_any_bills'],
    menu: [
      {
        icon: 'mdi-delete-alert',
        title: 'ລຶບລູກຄ້າສາຍບ້ານ',
        to: '/delete-home',
        permissions: ['delete_any_customers'],
      },
      {
        icon: 'mdi-delete-alert',
        title: 'ລຶບລູກຄ້າສາຍທຸລະກິດ',
        to: '/delete-company',
        permissions: ['delete_any_customers'],
      },
      {
        icon: 'mdi-delete-alert',
        title: 'ລຶບ-ແກ້ໄຂບີນ',
        to: '/delete-billing',
        permissions: ['delete_any_bills'],
      },
    ],
  },
];
